import {
  CLEAR_SHEDULE,
  CLEAR_SHEDULE_FLAGS,
  CREATE_SHEDULE_INIT,
  CREATE_SHEDULE_SUCCESS,
  DELETE_SHEDULE_INIT,
  DELETE_SHEDULE_SUCCESS,
  UPDATE_SHEDULE_INIT,
  UPDATE_SHEDULE_SUCCESS,
  ERROR_SHEDULE,
  LIST_SHEDULE_INIT,
  LIST_SHEDULE_SUCCESS
} from 'src/redux/actionTypes';
import { ISchedule } from 'src/integracoes/servicos/pgloader/modelos/ISchedule';

const INIT_STATE = {
  shedules: [] as ISchedule[],
  loading: false,
  isError: false,
  msg: '',
  success: false,
  isCreated: false,
  isUpdated: false,
  isDeleted: false
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LIST_SHEDULE_INIT:
      return { ...state, loading: true, success: false };
    case LIST_SHEDULE_SUCCESS:
      return { ...state, loading: false, shedules: action.payload, success: true };
    case CREATE_SHEDULE_INIT:
      return { ...state, loading: true, isCreated: false };
    case CREATE_SHEDULE_SUCCESS: {
      const { isCreated, msg } = action.payload;
      return { ...state, loading: false, msg, isCreated };
    }
    case UPDATE_SHEDULE_INIT:
      return { ...state, loading: true, isUpdated: false };
    case UPDATE_SHEDULE_SUCCESS: {
      const { isUpdated, msg } = action.payload;
      return { ...state, loading: false, msg, isUpdated };
    }
    case DELETE_SHEDULE_INIT:
      return { ...state, isDeleted: false };
    case DELETE_SHEDULE_SUCCESS: {
      const { isDeleted, msg } = action.payload;
      return { ...state, isDeleted, msg };
    }
    case ERROR_SHEDULE: {
      const { msg } = action.payload;
      return { ...state, loading: false, msg, isError: true };
    }
    case CLEAR_SHEDULE:
      return { ...INIT_STATE };
    case CLEAR_SHEDULE_FLAGS:
      return { ...state, isCreated: false, isError: false, isDeleted: false, isUpdated: false, msg: '' };
    default:
      return { ...state };
  }
};
